import { mapMutations } from 'vuex';

var timeOut;

const mutations = {
    timeOut: false,
    ...mapMutations([
        'setObjValue'
    ])
}

export default ( items, fields, e ) => {
    var keyCode = e && e.keyCode;
    if ( [9,16,27,38,40].indexOf(keyCode) > -1 ) return;

    clearTimeout(timeOut);

    timeOut = setTimeout(() => {
        items.forEach(item => {
            mutations.setObjValue({ obj: item, k: 'show', v: true });
            Array.isArray(item.cards) && item.cards.forEach(card => mutation.setObjValue({ obj: card, k: 'show', v: true }))
        });
        fields.forEach(field => {
                var p = {};
                if ( field.order ) {
                    switch ( field.type ) {
                        case 'date':
                            console.log('sort',field.field,field.order == 'asc' ? -1 : 1)
                            break;
                        default: 
                        console.log('sort',field.field,field.order == 'asc' ? 1 : -1)
                    }
                    
                }
                if ( field.value.length == 0 ) return;

                if ( field.type == 'num' ) {

                    var val = field.value;
                    var $lt = val.split('<')[1] && parseFloat(val.split('<')[1].split('>')[0]);
                    var $gt = val.split('>')[1] && parseFloat(val.split('>')[1].split('<')[0]);
                    if ( !isNaN($lt) ) { p[field.field] = { $lt: $lt } }
                    if ( !isNaN($gt) ) { p[field.field] = p[field.field] || {}; p[field.field].$gt = $gt; }
                    if ( !p[field.field]   ) { p[field.field] = { $eq: parseInt(val) } }

                } else {

                    p[field.field] = { $regex: field.value, $options: 'i' }
                }
                if ( p[field.field].$regex ) {
                    var text = new RegExp(p[field.field].$regex.split('').join(' *'),'i')

                    switch ( field.field ) {
                        case 'cards':
                        items.forEach(wallet => {
                            var showWallet = wallet.cards.reduce((p,card) => {
                                var showCard = text.test(card.title);
                                this.setObjValue({ obj: card, k: 'show', v: showCard });
                                return p || showCard;
                            },false);
                            this.setObjValue({ obj: wallet, k: 'show', v: showWallet });
                        });
                        break;
                        default:
                        items.forEach((item) => {
                            mutations.setObjValue({ obj: item, k: 'show', v: text.test(item[field.field]) })
                        })
                    }

                }
            
                if ( p[field.field].$gt ) {

                }

                if ( p[field.field].$lt ) {

                }

                if ( p[field.field].$eq ) {

                }
                
                return console.log('filter',JSON.stringify(p,null,1));                
        })     
    },200);

}

